module.exports = __webpack_public_path__ + "media/NeueHaasUnicaW1G-Heavy.eot";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/NeueHaasUnicaW1G/NeueHaasUnicaW1G-Heavy.eot
// module id = 582
// module chunks = 57